import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { ADMIN_SESSION_URL } from '../constants';

export default function useAdministrationAccess() {
  const { token } = useContext(AuthContext);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ token: null, session: null, loading: false, error: null });
  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();
    setState({ token, session: null, loading: true, error: null });
    axios.get(ADMIN_SESSION_URL, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal })
      .then(response => {
        if (!controller.signal.aborted) setState({ token, session: response.data, loading: false, error: null });
      }).catch(error => {
        if (!controller.signal.aborted) setState({ token, session: null, loading: false,
          error: { status: error.response?.status, message: error.response?.status === 401
            ? 'Tu sesión venció. Inicia sesión nuevamente.' : 'No se pudieron comprobar tus permisos. Intenta nuevamente.' } });
      });
    return () => controller.abort();
  }, [token, attempt]);
  const current = token && state.token === token ? state : { session: null, loading: Boolean(token), error: null };
  return { ...current, reload: () => setAttempt(value => value + 1) };
}
